/** Matches a single extended pictographic emoji sequence (ZWJ, VS, skin tone). */
const EMOJI_SEQUENCE_RE =
  /\p{Extended_Pictographic}(?:\u200d\p{Extended_Pictographic})*(?:\p{Emoji_Modifier}|\uFE0F)*/gu

/**
 * @param {string} text
 * @returns {boolean}
 */
export function isEmojiOnlyMessage(text) {
  const trimmed = typeof text === 'string' ? text.trim() : ''
  if (!trimmed) return false
  const withoutEmoji = trimmed.replace(EMOJI_SEQUENCE_RE, '').replace(/\s+/g, '')
  return withoutEmoji.length === 0
}

/**
 * @param {string} text
 * @returns {Array<{ type: 'text' | 'emoji', value: string }>}
 */
export function splitMessageByEmoji(text) {
  if (typeof text !== 'string' || !text) return []

  const segments = []
  let lastIndex = 0
  EMOJI_SEQUENCE_RE.lastIndex = 0

  for (const match of text.matchAll(EMOJI_SEQUENCE_RE)) {
    const index = match.index ?? 0
    if (index > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, index) })
    }
    segments.push({ type: 'emoji', value: match[0] })
    lastIndex = index + match[0].length
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) })
  }

  return segments.length > 0 ? segments : [{ type: 'text', value: text }]
}

export function messageHasEmoji(text) {
  if (typeof text !== 'string' || !text) return false
  EMOJI_SEQUENCE_RE.lastIndex = 0
  return EMOJI_SEQUENCE_RE.test(text)
}
